import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

// framework
import { Container, Row, Col, Form } from "react-bootstrap";

// styles

// components
import { Btn, BreadCrumb, Input, Check, InputFile } from "../../../components";

// utils
import { NOTIFICATION_OPTIONS, UPLOAD_TYPE } from "../../../utils/service";

const NewsletterAdd = () => {
  // const location = useLocation();
  const [setCategoryDefaultValue] = useState("All");

  // const paramVar = location.param;
  // const [param, setParam] = useState(paramVar);

  const breadcrumb = [
    {
      label: "Newsletters",
      href: "/newsletter/list",
      active: false,
    },
    {
      label: "Add New",
      href: "/newsletter/add",
      active: true,
    },
  ];

  useEffect(() => {}, []);

  // navigation
  const history = useHistory();
  const navigation = (href, params) => {
    history.push({
      pathname: href,
      param: params,
    });
  };

  return (
    <React.Fragment>
      {/* <NavHeader/> */}
      <div className="screen-wrap">
        <Container>
          <BreadCrumb data={breadcrumb}></BreadCrumb>
          <div className="screen-view-wrap">
            <div className="screen-view-row">
              <Row>
                <Col lg={6} sm={12} className="d-flex">
                  <div className="screen-title-wrap d-flex align-self-center">
                    <div className="text-wrap">
                      <p className="subtitle1">Add New</p>
                    </div>
                  </div>
                </Col>
                <Col lg={6} sm={12}>
                  <div className="btn-wrap d-flex justify-content-end">
                    <Btn
                      variant="secondary"
                      size={"lg"}
                      label="Go Back"
                      onClick={() => navigation("/newsletter/list", "")}
                    />
                  </div>
                </Col>
              </Row>
            </div>
            <div className="screen-view-row">
              <Form className="form-wrap">
                <Row>
                  <Col lg={6} sm={12}>
                    <Input
                      label="Newsletter Name"
                      placeholder="Enter Newsletter Name"
                      type="input"
                      id="headline"
                      maxLength={50}
                      showLength={true}
                      onChange={(data) => {
                        //console.log(data.target.value, "--- input");
                      }}
                    />
                    <InputFile
                      label="Add Newsletter File"
                      placeholder="Attachment"
                      id="attachment"
                      caption="Accepted formats: .pdf"
                      accept="application/pdf"
                      onChange={(data) => {
                        //console.log(data.target.value, "--- input");
                      }}
                      isAvtar={false}
                    />
                    <Check
                      id="upload_type"
                      data={UPLOAD_TYPE}
                      // defaultValue={"Upload This And Show This In Mobile App"}
                      type="radio"
                      onChange={(val) => {
                        //console.log(val, "--- checkValue");
                        setCategoryDefaultValue(val);
                      }}
                    />
                  </Col>
                  <Col lg={6} sm={12}>
                    <Check
                      label="Newsletter For"
                      id="newsletter_for"
                      data={NOTIFICATION_OPTIONS}
                      // defaultValue={categoryDefaultValue}
                      type="radio"
                      onChange={(val) => {
                        //console.log(val, "--- checkValue");
                        setCategoryDefaultValue(val);
                      }}
                    />
                    <Form.Group className="form-group" controlId="archive">
                      <Form.Check
                        type="checkbox"
                        label="Archive"
                        defaultChecked={true}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
            </div>
            <div className="screen-view-row">
              <Row>
                <Col lg={12} sm={12}>
                  <div className="btn-wrap d-flex justify-content-end">
                    <Btn
                      variant="secondary"
                      size={"lg"}
                      label="Cancel"
                      onClick={() => {
                        navigation("/newsletter/list", "");
                      }}
                    />
                    <Btn
                      variant="primary"
                      size={"lg"}
                      label="Submit"
                      onClick={() => {}}
                    />
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default NewsletterAdd;
